'use client';

import { c as _c } from "react/compiler-runtime";
import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area';
import * as React from 'react';
import { cn } from '@/lib/utils';
const ScrollBar = t0 => {
  const $ = _c(15);
  let className;
  let props;
  let ref;
  let t1;
  if ($[0] !== t0) {
    ({
      ref,
      className,
      orientation: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = ref;
    $[4] = t1;
  } else {
    className = $[1];
    props = $[2];
    ref = $[3];
    t1 = $[4];
  }
  const orientation = t1 === undefined ? "vertical" : t1;
  const t2 = orientation === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]";
  const t3 = orientation === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-[1px]";
  let t4;
  if ($[5] !== className || $[6] !== t2 || $[7] !== t3) {
    t4 = cn("flex touch-none select-none transition-colors", t2, t3, className);
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ScrollAreaPrimitive.ScrollAreaThumb className="relative flex-1 rounded-full bg-border" />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== orientation || $[11] !== props || $[12] !== ref || $[13] !== t4) {
    t6 = <ScrollAreaPrimitive.ScrollAreaScrollbar ref={ref} orientation={orientation} className={t4} {...props}>{t5}</ScrollAreaPrimitive.ScrollAreaScrollbar>;
    $[10] = orientation;
    $[11] = props;
    $[12] = ref;
    $[13] = t4;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
const ScrollArea = t0 => {
  const $ = _c(16);
  let children;
  let className;
  let props;
  let ref;
  if ($[0] !== t0) {
    ({
      ref,
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = ref;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    ref = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn("relative overflow-hidden", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== children) {
    t2 = <ScrollAreaPrimitive.Viewport className="size-full rounded-[inherit]">{children}</ScrollAreaPrimitive.Viewport>;
    $[7] = children;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ScrollBar />;
    t4 = <ScrollAreaPrimitive.Corner />;
    $[9] = t3;
    $[10] = t4;
  } else {
    t3 = $[9];
    t4 = $[10];
  }
  let t5;
  if ($[11] !== props || $[12] !== ref || $[13] !== t1 || $[14] !== t2) {
    t5 = <ScrollAreaPrimitive.Root ref={ref} className={t1} {...props}>{t2}{t3}{t4}</ScrollAreaPrimitive.Root>;
    $[11] = props;
    $[12] = ref;
    $[13] = t1;
    $[14] = t2;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName;
ScrollBar.displayName = ScrollAreaPrimitive.ScrollAreaScrollbar.displayName;
export { ScrollArea, ScrollBar };